export default {
  storiesCompilationState(state) {
    return state.compilation || {};
  },
  storiesCompilationLoadingState(state) {
    return state.compilationLoading;
  },
  updateStoryLoadingState(state, payload) {
    return state.updateStoryLoading;
  },
  updateStoriesCompilationLoadingState(state) {
    return state.updateCompilationLoading;
  },
  storiesCompilationsListState(state) {
    return state.compilationsList || [];
  },
  storiesCompilationsListLoadingState(state) {
    return state.compilationsListLoading;
  },
  storiesListState(state) {
    return state.storiesList || [];
  },
  storiesMetaState(state) {
    return state.storiesMeta || {};
  },
  storiesListLoadingState(state) {
    return state.storiesLoading;
  },
  storiesOptionsState(state) {
    return state.storiesOptions || {};
  },

  storyState(state) {
    return state.story || {};
  },
  storyLoadingState(state) {
    return state.storyLoading;
  },
  storyPinLoadingState(state) {
    return state.storyPinLoading;
  },
  storyCreateLoadingState(state) {
    return state.storyCreateLoading;
  },
  storyCreateInitData(state) {
    return state.storyCreateInitData || {};
  },
};
